import {
  USER_TODO_COMPLETED_LIST_FAIL,
  USER_TODO_COMPLETED_LIST_REQUEST,
  USER_TODO_COMPLETED_LIST_SUCCESS,
  USER_TODO_COMPLETED_TIME_LIST_FAIL,
  USER_TODO_COMPLETED_TIME_LIST_REQUEST,
  USER_TODO_COMPLETED_TIME_LIST_SUCCESS,
  USER_PREV_TODO_COMPLETED_LIST_FAIL,
  USER_PREV_TODO_COMPLETED_LIST_REQUEST,
  USER_PREV_TODO_COMPLETED_LIST_SUCCESS,
  USER_TODO_INCOMPLETE_LIST_FAIL,
  USER_TODO_INCOMPLETE_LIST_REQUEST,
  USER_TODO_INCOMPLETE_LIST_SUCCESS,
  USER_TODO_TOTAL_COMPLETED_LIST_FAIL,
  USER_TODO_TOTAL_COMPLETED_LIST_REQUEST,
  USER_TODO_TOTAL_COMPLETED_LIST_SUCCESS,
  USER_TODO_TIME_MONTH_LIST_FAIL,
  USER_TODO_TIME_MONTH_LIST_REQUEST,
  USER_TODO_TIME_MONTH_LIST_SUCCESS,
  USER_TODO_TOTAL_LIST_FAIL,
  USER_TODO_TOTAL_LIST_REQUEST,
  USER_TODO_TOTAL_LIST_SUCCESS,
  USER_TODO_TODAY_LIST_FAIL,
  USER_TODO_TODAY_LIST_REQUEST,
  USER_TODO_TODAY_LIST_SUCCESS,
  USER_TODO_DELETE_FAIL,
  USER_TODO_DELETE_REQUEST,
  USER_TODO_DELETE_SUCCESS,
  USER_ADD_TODO_TIME_FAIL,
  USER_ADD_TODO_TIME_REQUEST,
  USER_ADD_TODO_TIME_SUCCESS,
} from "../../types/user/todoTypes";

export const completedTodoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODO_COMPLETED_LIST_REQUEST:
      return {
        ...state,
        todoLoading: true,
      };
    case USER_TODO_COMPLETED_LIST_SUCCESS:
      return {
        ...state,
        todoLoading: false,
        UserCompletedTodoInfo: payload,
        todoError: "",
      };
    case USER_TODO_COMPLETED_LIST_FAIL:
      return {
        ...state,
        todoLoading: false,
        UserCompletedTodoInfo: [],
        todoError: payload,
      };
    default:
      return state;
  }
};

export const deleteTodoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODO_DELETE_REQUEST:
      return {
        ...state,
        todoDelLoading: true,
      };
    case USER_TODO_DELETE_SUCCESS:
      return {
        ...state,
        todoDelLoading: false,
        UserDelTodoInfo: payload,
        todoDelError: "",
      };
    case USER_TODO_DELETE_FAIL:
      return {
        ...state,
        todoDelLoading: false,
        UserDelTodoInfo: [],
        todoDelError: payload,
      };
    default:
      return state;
  }
};

export const TodayTodoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODO_TODAY_LIST_REQUEST:
      return {
        ...state,
        todoTodayLoading: true,
      };
    case USER_TODO_TODAY_LIST_SUCCESS:
      return {
        ...state,
        todoTodayLoading: false,
        UserTodayTodoInfo: payload,
        todoTodayError: "",
      };
    case USER_TODO_TODAY_LIST_FAIL:
      return {
        ...state,
        todoTodayLoading: false,
        UserTodayTodoInfo: [],
        todoTodayError: payload,
      };
    default:
      return state;
  }
};

export const completedPrevTodoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PREV_TODO_COMPLETED_LIST_REQUEST:
      return {
        ...state,
        todoPrevLoading: true,
      };
    case USER_PREV_TODO_COMPLETED_LIST_SUCCESS:
      return {
        ...state,
        todoPrevLoading: false,
        UserCompletedPrevTodoInfo: payload,
        todoPrevError: "",
      };
    case USER_PREV_TODO_COMPLETED_LIST_FAIL:
      return {
        ...state,
        todoPrevLoading: false,
        UserCompletedPrevTodoInfo: [],
        todoPrevError: payload,
      };
    default:
      return state;
  }
};

export const completedTimeTodoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODO_COMPLETED_TIME_LIST_REQUEST:
      return {
        ...state,
        TimeTodoLoading: true,
      };
    case USER_TODO_COMPLETED_TIME_LIST_SUCCESS:
      return {
        ...state,
        TimeTodoLoading: false,
        UserCompletedTimeTodoInfo: payload,
        TimeTodoError: "",
      };
    case USER_TODO_COMPLETED_TIME_LIST_FAIL:
      return {
        ...state,
        TimeTodoLoading: false,
        UserCompletedTimeTodoInfo: [],
        TimeTodoError: payload,
      };
    default:
      return state;
  }
};

export const inCompletedTodoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODO_INCOMPLETE_LIST_REQUEST:
      return {
        ...state,
        inCompleteLoading: true,
      };
    case USER_TODO_INCOMPLETE_LIST_SUCCESS:
      return {
        ...state,
        inCompleteLoading: false,
        inCompleteInfo: payload,
        inCompleteError: "",
      };
    case USER_TODO_INCOMPLETE_LIST_FAIL:
      return {
        ...state,
        inCompleteLoading: false,
        inCompleteInfo: [],
        inCompleteError: payload,
      };
    default:
      return state;
  }
};

export const CompletedTotalTodoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODO_TOTAL_COMPLETED_LIST_REQUEST:
      return {
        ...state,
        totalCompleteLoading: true,
      };
    case USER_TODO_TOTAL_COMPLETED_LIST_SUCCESS:
      return {
        ...state,
        totalCompleteLoading: false,
        totalCompleteInfo: payload,
        totalCompleteError: "",
      };
    case USER_TODO_TOTAL_COMPLETED_LIST_FAIL:
      return {
        ...state,
        totalCompleteLoading: false,
        totalCompleteInfo: [],
        totalCompleteError: payload,
      };
    default:
      return state;
  }
};

export const TotalTodoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODO_TOTAL_LIST_REQUEST:
      return {
        ...state,
        totalLoading: true,
      };
    case USER_TODO_TOTAL_LIST_SUCCESS:
      return {
        ...state,
        totalLoading: false,
        totalInfo: payload,
        totalError: "",
      };
    case USER_TODO_TOTAL_LIST_FAIL:
      return {
        ...state,
        totalLoading: false,
        totalInfo: [],
        totalError: payload,
      };
    default:
      return state;
  }
};

export const monthTodoTimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODO_TIME_MONTH_LIST_REQUEST:
      return {
        ...state,
        monthTodoTimeLoading: true,
      };
    case USER_TODO_TIME_MONTH_LIST_SUCCESS:
      return {
        ...state,
        monthTodoTimeLoading: false,
        monthTodoTimeInfo: payload,
        monthTodoTimeError: "",
      };
    case USER_TODO_TIME_MONTH_LIST_FAIL:
      return {
        ...state,
        monthTodoTimeLoading: false,
        monthTodoTimeInfo: [],
        monthTodoTimeError: payload,
      };
    default:
      return state;
  }
};

export const userAddTodoTimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ADD_TODO_TIME_REQUEST:
      return {
        ...state,
        addTodoTimeLoading: true,
      };
    case USER_ADD_TODO_TIME_SUCCESS:
      return {
        ...state,
        addTodoTimeLoading: false,
        addTodoTimeInfo: payload,
        addTodoTimeError: "",
      };
    case USER_ADD_TODO_TIME_FAIL:
      return {
        ...state,
        addTodoTimeLoading: false,
        addTodoTimeInfo: [],
        addTodoTimeError: payload,
      };
    default:
      return state;
  }
};
